import React from 'react';
import './slider-fabrisorbceilingcloud.css';
import Bannerb1 from '../../images/fabrisorb-acoustic-ceiling-clouds-1.webp';
import Bannerb2 from '../../images/fabrisorb-acoustic-ceiling-clouds-2.webp';
function slider() {
    return (

        <>
            <div id="slider-fabrisorbceilingcloud">
                <div id="carouselExampleIndicators6" className="carousel slide" data-ride="carousel" data-interval="2000">
                    <ol className="carousel-indicators">
                        <li data-target="#carouselExampleIndicators6" data-slide-to="0" className="active"></li>
                        <li data-target="#carouselExampleIndicators6" data-slide-to="1"></li>
                    </ol>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img className="d-block w-100" src={Bannerb1} alt="Fabrisorb ceiling clouds" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Ceiling Clouds</h2>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="d-block w-100" src={Bannerb2} alt="Fabrisorb ceiling clouds" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Ceiling Clouds</h2>
                            </div>
                        </div>
                    </div>
                    <a className="carousel-control-prev" href="#carouselExampleIndicators6" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleIndicators6" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </>
    );
}
export default slider;